import React, { useState } from 'react'
import { Row, Col } from 'reactstrap'
import styled from 'styled-components'
import poweredOcio from 'img/powered-ociobusiness-white-h'
import { useTranslation } from 'react-i18next'
import { usePartial } from 'i18n/config'
import Modal from 'ui/modal'
import clientConfig from 'config/client_config.json'

const FooterWrapper = styled.footer`
  margin-top: 7em;
`

const Footer = (props) => {
  const { i18n } = useTranslation()
  const { supportTelephone } = clientConfig
  const {client_params} = props
  const { site_name } = props

  // TODO: Unificar el acceso a user, tanto en list controller como purchase
  let user = null

  if (props?.user?.user) {
    user = props.user.user
  } else {
    user = props?.user?.user_data?.user
  }

  const saleChannel = user?.sale_channel

  const LegalWarningLink = () => {
    const LegalWarning = usePartial('auth/legal_warning', {
      supportTelephone,
      site_name,
    })
    const [modal, setModal] = useState(false)
    const toggle = () => setModal(!modal)

    return (
      <>
        <button
          type="button"
          className="btn btn-link text-white text-decoration-none me-3 p-0"
          onClick={toggle}
        >
          {i18n.t('sign_in.legal_warning')}
        </button>
        <Modal
          isOpen={modal}
          toggle={toggle}
          header={i18n.t('sign_in.legal_warning')}
          width="90%"
        >
          <LegalWarning
            supportTelephone={supportTelephone}
            site_name={site_name}
          />
        </Modal>
      </>
    )
  }

  const ReturnPolicyLink = () => {
    const ReturnPolicy = usePartial('auth/return_policy', {
      supportTelephone,
      site_name,
    })
    const [modal, setModal] = useState(false)
    const toggle = () => setModal(!modal)

    return (
      <>
        <button
          type="button"
          className="btn btn-link text-white text-decoration-none p-0"
          onClick={toggle}
        >
          {i18n.t('sign_in.return_policy')}
        </button>
        <Modal
          isOpen={modal}
          toggle={toggle}
          header={i18n.t('sign_in.return_policy')}
          width="90%"
        >
          <ReturnPolicy supportTelephone={supportTelephone} />
        </Modal>
      </>
    )
  }

  const year = new Date().getFullYear()

  return (
    <FooterWrapper className="bg-dark py-3 text-white">
      <div className="container">
        <Row className="d-flex flex-column-reverse flex-md-row align-items-center text-center text-md-start">
          <Col xs="12" md="4" className="mt-3 mt-md-0">
            <span>
              {site_name} © {year}
            </span>
          </Col>

          <Col xs="12" md="4" className="my-3 my-md-0 text-center">
            <a
              className="text-white text-decoration-none"
              href="https://ociobusiness.es/"
              target="_blank"
              rel="noreferrer"
            >
              Powered by{' '}
              <img
                src={poweredOcio}
                height="20"
                alt="OcioBusiness logo"
                className="ms-1"
              />
            </a>
            {user && saleChannel == 'b2c' &&
              <div className="text-center">
                <small>Ref: {user.id}</small>
              </div>
            }
          </Col>

          <Col
            xs="12"
            md="4"
            className="d-flex justify-content-center justify-content-md-end"
          >
            <LegalWarningLink />
            <ReturnPolicyLink />
          </Col>
        </Row>
      </div>
    </FooterWrapper>
  )
}

export default Footer
